// export this package's api
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _QueueAnim = require('./QueueAnim');

var _QueueAnim2 = _interopRequireDefault(_QueueAnim);

exports['default'] = _QueueAnim2['default'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-queue-anim/lib/index.js
 ** module id = 333
 ** module chunks = 0
 **/